export class IsiComponentClientEventArgs {

    IsiCommand: string = "";
    IsiSenderId: string = "";
    IsiEventName: string = "";
    IsiData: any = {};
    IsiStringData: string = "";
    IsiDto: any = null;
    IsiReturnData: any = {};
    IsiAsyncCallId: number = -1;
    bStopPropagation: boolean = false;

    constructor(command, senderId, eventName, data, dto) {
        //this.__type = "IsiComponentClientEventArgs:#Isilog.IsiFramework.IsiWebGUI";
        this.IsiCommand = command;
        this.IsiSenderId = senderId;
        this.IsiEventName = eventName;
        this.IsiData = data;
        this.IsiStringData = "\"" + jQuery.toJSON(data) + "\"";
        this.IsiDto = dto;
        this.IsiReturnData = {};
        //GBAU - 14/09/2012 - DYSF51947 : On initialise à -1 au lieu de null pour éviter les problèmes de désérialisation coté serveur
        this.IsiAsyncCallId = -1;
        this.bStopPropagation = false;
    }

    stopPropagation() {
        this.bStopPropagation = true;
    }

    getStopPropagation() {
        return this.bStopPropagation;
    }
}